import { connect } from 'react-redux'

import SearchDialog from '../components/search-dialog'

const mapStateToProps = ({ initial: { endpoints, user } }) => ({
    customersAPIURL: endpoints.customersAPIURL.replace('user_pk', user.id),
})

export default connect(mapStateToProps)(SearchDialog)
